// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_unauthenticated_unauthenticated_module_ts":"bc5d027d74616641","src_app_authenticated_authenticated_module_ts":"e7920371cd3d6bd6"}[chunkId] + ".js";
};